<template>
  <div :class="{ oringinalBg: !emitChange, bgChange: emitChange }">
    <div class="containter">
      <div class="row">
        <div class="col-8 offset-2" v-if="actionIndex < -1">
          <mission-ranking :users="users" />
        </div>
      </div>

      <div class="row pt-5" v-if="actionIndex === -1">
        <div class="col-6 col-lg-4 offset-lg-2">
          <h5 class="h5">頻道號碼：{{ channelId }}</h5>
          <qrcode :value="channelId" :options="{ width: 400 }"></qrcode>
        </div>

        <div class="col-6 col-lg-4">
          <h4 class="h4">學生列表</h4>
          <ul class="list-group">
            <li class="list-group-item d-flex" v-for="item in users" :key="item.UserId">
              <div class="mr-auto"> {{ item.NickName }}</div>
              <div>
                <span class="btn btn-xs btn-outline-warning" disabled v-if="!item.isReady">已加入</span>
                <span class="btn btn-xs btn-success" disabled v-else>準備完成</span>
              </div>
            </li>
          </ul>
        </div>

        <div class="col-12 text-center p-5">
          <button class="btn btn-xs btn-pink" @click="nextAction()">準備完成</button>
        </div>
      </div>

      <div class="row" v-if="actionIndex > -1">
        <div class="col-8 offset-2" v-show="!isActionFinish">
          <mission :ref="'mission'"
            v-for="(item, index) in actions" :key="item.id"
            v-on:changeBg="changeBg"
            :content="item"
            :users="users"
            v-if="actionIndex === index"
            v-on:showAnswer="actionResult()" />
        </div>

        <div class="col-8 offset-2" v-show="isActionFinish">
          <mission-next :content="actions[actionIndex]" v-on:next="nextAction()" />
        </div>

        <div class="col-4" v-if="false">
          <h4 class="h4">學生列表</h4>
          <ul class="list-group">
            <li class="list-group-item d-flex"
              v-for="item in users" :key="item.UserId">
              <div class="mr-auto">{{ item.NickName }}</div>
              <div v-if="getUserActionAnswer(item)">你選擇了 {{ getUserActionAnswer(item) }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/apiMixin'
import MissionExplanation from '@/components/MissionExplanation.vue'
import MissionStart from '@/components/MissionStart.vue'
import Mission from '@/components/Mission.vue'
import MissionNext from '@/components/MissionNext.vue'
import MissionRanking from '@/components/MissionRanking.vue'

export default {

  name: 'Play',

  components: {
    MissionExplanation,
    MissionStart,
    Mission,
    MissionNext,
    MissionRanking
  },

  mixins: [api],

  data () {
    return {
      id: null,
      channelId: null,
      actions: [],
      actionIndex: -1,
      isActionFinish: false,
      ballColor: 'A',
      mission: 1,
      emitChange: null
    }
  },

  computed: {
    actionId () {
      return this.actions[this.actionIndex] ? this.actions[this.actionIndex].id : ''
    }
  },

  mounted () {
    this.id = this.$route.params.activityId
    this.start()
  },

  destroyed () {
    this.socketClose()
  },

  methods: {
    start () {
      let self = this

      this.APIPostActivityChannel(this.id).then((data) => {
        self.channelId = data.channel
        self.socketInit(self.channelId)
        // self.socketSendMessage({
        //   'ActivityFlow': 'JoinActivity'
        // })
      })

      this.APIGetActivityActions(this.id).then((data) => {
        self.actions = data
      })
    },

    nextAction () {
      this.isActionFinish = false

      let self = this
      if (this.actions[this.actionIndex]) {
        this.users.forEach((user) => {
          if (self.getUserActionAnswer(user) === self.actions[self.actionIndex].answer) {
            user.rightCount += 1
          }
        })
      }

      if (this.actionIndex < this.actions.length - 1) {
        this.actionIndex += 1
        this.socketSendMessage({
          'ActivityFlow': 'ActionStart',
          'Data': this.actions[this.actionIndex].id
        })
      } else {
        this.users.sort((a, b) => {
          if (a.rightCount > b.rightCount) {
            return -1
          }

          if (a.rightCount < b.rightCount) {
            return 1
          }

          return 0
        })

        this.actionIndex = -2
        this.socketSendMessage({
          'ActivityFlow': 'ExitActivity'
        })
        this.socketClose()
      }
    },

    actionResult () {
      this.isActionFinish = true

      this.socketSendMessage({
        'ActivityFlow': 'ActionResult'
      })
    },

    getUserActionAnswer (user) {
      let idx = user.actions.map((e) => { return e.actionId }).indexOf(this.actionId)

      return (idx > -1) ? user.actions[idx].answer : ''
    },

    showImage (url) {
      this.$swal({
        imageUrl: url,
        imageHeight: 500,
        animation: false,
        grow: 'fullscreen',
        background: 'rgba(0, 0, 0, 0.5)',
        showCloseButton: true,
        showConfirmButton: false
      })
    },

    countActionAnswer (answer) {
      let self = this
      let count = 0
      answer = String.fromCharCode(65 + answer)

      this.users.forEach((e) => {
        if (self.getUserActionAnswer(e) === answer) {
          count += 1
        }
      })

      return (count / this.users.length) * 100 ? (count / this.users.length) * 100 : 0
    },

    throwBall (answer) {
      let number = answer.charCodeAt(0) - 65
      let color = ['red', 'green', 'blue']
      this.$refs.mission[0].createColorBall(color[number])
    },

    changeBg (changeBg) {
      this.emitChange = changeBg
      let vm = this
      let tout = this.emitChange

      if (tout) {
        clearTimeout(tout)
        tout = setTimeout(function () {
          tout = null
          vm.emitChange = false
        }, 4000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .oringinalBg {
    min-height: calc(100vh - 220px);
    width: 100%;
    background-image: url("../../assets/images/pic_bg_03.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .bgChange {
    min-height: calc(100vh - 220px);
    width: 100%;
    background-image: url("../../assets/images/pic_bg_04.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
</style>
